/**
 * Guard503A
 * ------------------------------------------------------------------
 * Wraps 503A-shaped pages (legacy EMR, Inventory, Compounding,
 * Reports, Training, Audit). If the current tenant is flagged as a
 * 503B outsourcing facility, we transparently redirect them to the
 * 503B equivalent so they never see 503A patient/prescription concepts.
 */
import { useLocation } from 'react-router-dom';
import { use503BRedirect } from '../hooks/use503BRedirect';

export function Guard503A({ children }: { children: React.ReactNode }) {
    const { pathname } = useLocation();
    const { checked, is503B } = use503BRedirect(pathname);

    // Until we've probed 503B status, render children — the redirect fires
    // once the probe completes.
    if (checked && is503B) return null;
    return <>{children}</>;
}
